import TeamLayout from "./TeamLayout";

export default TeamLayout;
